import React from 'react';
import { Checkbox } from '@fluentui/react-components';
import { FacetValue, FacetValueCount, FacetValues } from '../../../types/Facet';


interface FacetFieldCheckboxesProps {
  facetValues: FacetValueCount<FacetValue>[];
  facetSelection: FacetValues<FacetValue> |  null;
  onChangeFacet: (name: string, valueKey: FacetValue, checked: boolean) => void;
  name: string;
}

const FacetFieldCheckboxes: React.FC<FacetFieldCheckboxesProps> = ({
  facetValues,
  facetSelection,
  onChangeFacet,
  name,
}) => {

  return (
    <ul>
      {facetValues.map((facetValue, index) => {

        const isChecked: boolean = 
            facetSelection?.facetValues.some(item => item.getStringValue() === facetValue.facetValue.getStringValue()) || false;
        const displayValue = facetValue.facetValue.getDisplayValue();
        const countDisplay = `(${facetValue.count})`;

        return (
          <li key={index}>
            <Checkbox
              label={`${displayValue} ${countDisplay}`}
              checked={isChecked}
              disabled={!facetValue.count}
              onChange={(_, data) => onChangeFacet(name, facetValue.facetValue, !!data.checked)}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default FacetFieldCheckboxes;
